import { FailureScreenProps } from "shared/games/types/GameConfiguration";
import { GameAnswerFrequencyFinder } from "shared/games/types/GameAnswers";
import { GameQuestionFrequencyFinder } from "shared/games/types/GameQuestions";
import * as GameLayout from "ui/templates/Game/LayoutComponents";
import Button from "ui/atoms/Button/Button";
import Graph from "../organisms/Graph/Graph";
import { useMountEffect } from "@react-hookz/web";
import { difficultyConfig, freqRange } from "../constants";
import { gameTypeToEQType } from "./gameTypeConvertors";

type Props = FailureScreenProps<
  GameQuestionFrequencyFinder,
  GameAnswerFrequencyFinder
>;

export default function FrequencyFinderFailedScreen({
  question,
  onLoaded,
  answer,
  onNext,
  mobileToolbarStyle,
}: Props) {
  const { q, safeAreaInOctaves } = difficultyConfig[question.difficulty];

  useMountEffect(() => {
    onLoaded();
  });

  return (
    <>
      <GameLayout.Toolbar mobileStyle={mobileToolbarStyle}>
        <div className={"flex justify-between"}>
          <div />

          <Button theme="green" size="large" onClick={onNext}>
            Next
          </Button>
        </div>
      </GameLayout.Toolbar>

      <GameLayout.Container>
        <Graph
          measurementKey={"frequency-finder"}
          type={gameTypeToEQType(question.type)}
          text={<span className={"text-red-500"}>Incorrect!</span>}
          freqRange={freqRange}
          freq={answer.submittedFrequency}
          correctFreq={answer.correctFrequency}
          onChange={noop}
          q={q}
          safeAreaInOctaves={safeAreaInOctaves}
        />
      </GameLayout.Container>
    </>
  );
}

const noop = () => {};
